import { ALL_LANGS, type Lang } from "~/data/i18n";

const rawList = (import.meta.env.VITE_AVAILABLE_LANGS ?? ALL_LANGS.join(","))
  .split(",")
  .map((s: string) => s.trim())
  .filter(Boolean);

const available = rawList.filter((l: string): l is Lang =>
  (ALL_LANGS as readonly string[]).includes(l),
);

if (available.length === 0) {
  throw new Error(
    `[i18nConfig] VITE_AVAILABLE_LANGS resolved to empty set. Got: ${JSON.stringify(rawList)}`,
  );
}

const rawDefault = (import.meta.env.VITE_DEFAULT_LANG ?? available[0]) as Lang;
if (!available.includes(rawDefault)) {
  throw new Error(
    `[i18nConfig] VITE_DEFAULT_LANG=${rawDefault} is not in VITE_AVAILABLE_LANGS=${available.join(",")}`,
  );
}

export const LANGS: readonly Lang[] = available;
export const DEFAULT_LANG: Lang = rawDefault;
